<template>
  <div>
    <el-drawer
      title="Detalle de CxC del empleado"
      :visible.sync="cxcDetailIsVisible"
      :append-to-body="true"
      size="60%"
      @close="closingCXCdetailDrawer"
    >
      <rabbey-table-3 :data="detailData" :columns="detailColumns" />
    </el-drawer>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
export default {
  name: "CXCdetails",
  props: {
    detailIsVisible: {
      type: Boolean,
      default: false
    },
    CXCdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      detailData: [],
      detailColumns: [
        {
          label: "Descripcion",
          prop: "Descripcion",
          "min-width": 100
        },
        {
          label: "Monto",
          prop: "Monto",
          "min-width": 100,
          formatter: (row) => formatMonto(row.Monto)
        },
        {
          label: "Fecha",
          prop: "Fecha",
          "min-width": 100,
          formatter: CellDateTime
        },
        {
          label: "Pagado?",
          prop: "Pagado",
          "min-width": 100
        }
      ]
    };
  },
  computed: {
    cxcDetailIsVisible() {
      return this.detailIsVisible;
    }
  },
  methods: {
    closingCXCdetailDrawer() {
      this.$emit("closingCXCdetailDrawer");
    }
  },
  watch: {
    detailIsVisible(val) {
      if (val === true) {
        this.detailData = this.CXCdata.CuotasCxc;
      }
    }
  }
};
</script>

<style></style>
